import "whatwg-fetch"
import React from "react"
import ReactDOM from "react-dom"

import TradeInWizard from "widgets/TradeInValuations/TradeInWizard"
import TestDriveBookingFlow from "widgets/TradeInValuations/TestDriveBookingFlow"
import { trackFunction } from "../website_script/lib/iframeTrackingHelper"
import syncParamsToLocalAbTesting from "../widgets/TradeInValuations/Utility/ABTesting/syncParamsToLocalAbTesting"
// Adds the trackingConstants global
import "website_script/lib/events"

syncParamsToLocalAbTesting()

document.addEventListener("DOMContentLoaded", () => {
  const wizardEl = document.querySelector("#trade-in-wizard")
  if (wizardEl) {
    const props = JSON.parse(wizardEl.getAttribute("data-props"))
    const tradeInWizard = ReactDOM.render(
      <TradeInWizard {...props} trackFunction={trackFunction} />,
      wizardEl
    )

    window.TradeInValuations.updateFlowSelector =
      tradeInWizard.updateFlowSelectorOptions
  }

  const bookTestDriveEl = document.querySelector("#book-test-drive")
  if (bookTestDriveEl) {
    const bookTestDriveProps = JSON.parse(
      bookTestDriveEl.getAttribute("data-props")
    )
    const bookingFlow = ReactDOM.render(
      <TestDriveBookingFlow
        {...bookTestDriveProps}
        trackFunction={trackFunction}
      />,
      bookTestDriveEl
    )
    window.TradeInValuations.updateFlowSelector = bookingFlow.updateFlowOptions
  }
})
